// Local storage helpers for buyer features
const get = (k, def = []) => { try { return JSON.parse(localStorage.getItem(k)) || def; } catch { return def; } };
const set = (k, v) => localStorage.setItem(k, JSON.stringify(v));

export const wishlist = {
  list: () => get('tgmart_wishlist'),
  has: (id) => get('tgmart_wishlist').includes(id),
  toggle: (id) => {
    const w = get('tgmart_wishlist');
    const idx = w.indexOf(id);
    if (idx >= 0) w.splice(idx, 1); else w.push(id);
    set('tgmart_wishlist', w);
    return w.includes(id);
  },
  remove: (id) => { set('tgmart_wishlist', get('tgmart_wishlist').filter((x) => x !== id)); },
};

export const recent = {
  list: () => get('tgmart_recent'),
  track: (id) => {
    const r = get('tgmart_recent').filter((x) => x !== id);
    r.unshift(id);
    set('tgmart_recent', r.slice(0, 12));
  },
};

export const compare = {
  list: () => get('tgmart_compare'),
  has: (id) => get('tgmart_compare').includes(id),
  toggle: (id) => {
    const c = get('tgmart_compare');
    const idx = c.indexOf(id);
    if (idx >= 0) c.splice(idx, 1);
    else if (c.length < 4) c.push(id);
    else return { error: 'You can compare up to 4 products only.' };
    set('tgmart_compare', c);
    return { ok: true, list: c };
  },
  clear: () => set('tgmart_compare', []),
};
